import React from 'react';
import classnames from 'classnames';
import Who from '../../Who';
import { isSimpleDeviation } from '../../DeviationViews/_helpers';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import { usePopoverOnInteraction } from '@wix/da-ds/pkg/popper/hooks/usePopoverOnInteraction';
const offsetModifier = [
    0,
    0
];
import s from './WhoTooltipWrapper.scss';
const WhoTooltipWrapper = ({ deviation, userListType, tooltipDataHook, dataHook, className, children })=>{
    const { isVisible, onMouseEnter, onMouseLeave } = usePopoverOnInteraction({
        listenOnHover: true,
        hideOnScroll: false
    });
    const noHover = isSimpleDeviation(deviation);
    if (noHover) {
        return /*#__PURE__*/ React.createElement("span", {
            className: classnames(s['tooltip-wrapper'], className),
            "data-hook": dataHook
        }, children);
    }
    return /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['root'], className),
        "data-hook": dataHook,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }, /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        isVisible: isVisible,
        popoverContent: /*#__PURE__*/ React.createElement(Who, {
            deviation: deviation,
            userListType: userListType,
            dataHook: tooltipDataHook
        }),
        directionalClassNames: {
            top: s['tooltip-top'],
            bottom: s['tooltip-bottom']
        },
        wrapperClassName: s['tooltip-wrapper'],
        offsetModifier: offsetModifier,
        usePortal: false
    }, children));
};
WhoTooltipWrapper.displayName = 'WhoTooltipWrapper';
export default WhoTooltipWrapper;
